import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Icon from 'components/Icon';
import Text from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('MessageDrawerListEmptyState')
export default class MessageDrawerListEmptyState extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    icon: PropTypes.string.isRequired,
  };

  render() {
    const { title, description, icon } = this.props;

    return (
      <Box pt48 paxs tcenter>
        <Icon size={48} type={icon} color="blueLight" />
        <Box tcenter pt16>
          <Text fs16 grayXdark i18n={title} />
        </Box>
        {description && (
          <Box ptm>
            <Text fs16 grayXdark i18n={description} />
          </Box>
        )}
      </Box>
    );
  }
}
